<template>
    <div>
        <div class="d-flex flex-column align-items-center">
            <h5 class="text-center">The token has expired or is invalid</h5>
            <BaseIcon class="error-color" name="sad-tear" size="3x" />

            <h6 class="text-center mt-5">Send a new email</h6>
            <form class="w-100" @submit.prevent="sendNewForgotPasswordEmail">
                <TextField
                    class="w-100"
                    v-model="email"
                    placeholder="Email"
                    type="email"
                    padding
                />
                <BaseButton class="mt-2 w-100" variant="primary"
                    >Send a new email</BaseButton
                >
            </form>

            <BaseButton class="mt-3 w-100" @click="backToChangePassword"
                >Or try again</BaseButton
            >
        </div>
    </div>
</template>

<script>
import states from '../states';
import { recoverPasswordURL } from '~/utils/urlUtils';

export default {
    name: 'ErrorModule',
    data: () => ({
        email: '',
    }),
    methods: {
        changeState(state) {
            this.$emit('stateChange', state);
        },
        backToChangePassword() {
            this.changeState(states.DEFAULT);
        },
        sendNewForgotPasswordEmail() {
            this.changeState(states.LOADING);
            this.$interfaces.user['forgot-password']
                .post({
                    body: {
                        email: this.email,
                        returnUrl: recoverPasswordURL(),
                    },
                })
                .then(() => {
                    this.showEmailSentMessage();
                })
                .catch(() => {
                    this.showEmailNotSentMessage();
                })
                .finally(() => {
                    this.backToChangePassword();
                });
        },
        showEmailSentMessage() {
            this.$interfaces.messageModule.addNewMessage({
                state: 'NOTIFICATION',
                title: 'Email sent!',
                message: 'New password-recovery email was successfully sent!',
                duration: 10000,
            });
        },
        showEmailNotSentMessage() {
            this.$interfaces.messageModule.addNewMessage({
                state: 'ERROR',
                title: 'Could not send email!',
                message:
                    'We were not able to send you a new password-recovery email.\nPlease try again.',
                duration: 10000,
            });
        },
    },
};
</script>

<style scoped></style>
